!function() {
  "use strict";
  customElements.get("product-reviews") || customElements.define("product-reviews", class extends HTMLElement {
    constructor() {
      super(), this.perPage = 5, this.currentReviewPage = 0, this.currentQuestionPage = 0, 
      this.topics = [], this.appkey = this.dataset.appkey, this.options = {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      };
    }
    connectedCallback() {
      this.appkey ? (this.init(), this.addEventListener("click", this.onClickHandler.bind(this)), 
      this.querySelectorAll("form").forEach((form => form.addEventListener("submit", this.onSubmitHandler.bind(this))))) : this.hide();
    }
    show() {
      this.closest(".max-h-0")?.classList.remove("max-h-0");
    }
    hide() {
      const section = this.closest(".shopify-section");
      section && section.parentNode.removeChild(section);
    }
    loadStart(el) {
      el?.classList.add("opacity-50", "cursor-wait", "pointer-events-none");
    }
    loadEnd(el) {
      el?.classList.remove("opacity-50", "cursor-wait", "pointer-events-none");
    }
    onClickHandler(event) {
      event.target.hasAttribute("data-reviews-loader") ? (event.preventDefault(), this.topics.length ? this.getFilteredReviews(this.currentReviewPage + 1) : this.getReviews(this.currentReviewPage + 1)) : event.target.hasAttribute("data-questions-loader") ? (event.preventDefault(), 
      this.getQuestions(this.currentQuestionPage + 1)) : event.target.hasAttribute("data-topic") && (event.preventDefault(), 
      "true" === event.target.ariaCurrent ? (this.topics = [], this.getReviews(1)) : (this.topics = [ event.target.textContent.trim() ], 
      this.getFilteredReviews(1)));
    }
    onSubmitHandler(event) {
      event.preventDefault(), this.loadStart(event.target);
      let body = Object.fromEntries(new FormData(event.target));
      body.appkey = this.appkey, body.sku = this.product.id.toString(), body.product_title = this.product.title, 
      body.product_url = `https://${Shopify.shop || location.host}${Shopify.routes.root || "/"}products/${this.product.handle}`, 
      fetch(event.target.action, {
        ...this.options,
        method: "POST",
        body: JSON.stringify(body)
      }).then((response => {
        response.ok ? event.target.parentNode.querySelector("[data-success]").classList.remove("hidden") : event.target.querySelector("[data-error]").classList.remove("hidden");
      })).catch((error => {
        console.error("error:" + error), event.target.querySelector("[data-error]").classList.remove("hidden");
      })).finally((() => this.loadEnd(event.target)));
    }
    updateCounts(response) {
      this.total = response.pagination?.total || response.bottomline?.total_review || "", 
      this.pages = Math.ceil(this.total / this.perPage);
    }
    renderSection(response) {
      this.updateCounts(response), this.querySelector("[data-rating]").textContent = response.bottomline?.average_score ? response.bottomline?.average_score?.toFixed(1) : "", 
      this.querySelector("[data-total-review]").textContent = this.total, this.show();
    }
    renderTopics(response) {
      const topicTemplate = this.querySelector("template[data-template-topic]"), container = this.querySelector("[data-topics]");
      response.top_topics?.top_mention_topics?.forEach((topic => {
        const topicClone = topicTemplate.content.cloneNode(!0);
        topicClone.querySelector("[data-topic]").innerHTML = topic.name, container.appendChild(topicClone);
      }));
    }
    renderReviews(response) {
      this.updateCounts(response);
      const reviewTemplate = this.querySelector("template[data-template-review]"), detailTemplate = this.querySelector("template[data-template-review-detail]"), container = this.querySelector("[data-reviews]");
      this.currentReviewPage || this.renderSection(response), this.currentReviewPage = response.pagination.page, 
      1 == this.currentReviewPage && (container.innerHTML = ""), response.reviews.forEach((review => {
        const reviewClone = reviewTemplate.content.cloneNode(!0);
        reviewClone.children[0].style.setProperty("--score", review.score), reviewClone.querySelector("[data-title]").innerHTML = review.title, 
        reviewClone.querySelector("[data-content]").innerHTML = review.content, reviewClone.querySelector("[data-display-name]").innerHTML = review.user.display_name, 
        review.verified_buyer || reviewClone.querySelector("[data-verified]").classList.remove("hidden"), 
        review.custom_fields && review.custom_fields.forEach((field => {
          const detailClone = detailTemplate.content.cloneNode(!0);
          detailClone.querySelector("[data-title]").innerHTML = field.title, detailClone.querySelector("[data-value]").innerHTML = field.value, 
          reviewClone.appendChild(detailClone);
        })), container.appendChild(reviewClone);
      })), this.currentReviewPage >= this.pages ? this.querySelector("[data-reviews-loader]").classList.add("hidden") : this.querySelector("[data-reviews-loader]").classList.remove("hidden"), 
      this.querySelectorAll("[data-topic]").forEach((topic => topic.ariaCurrent = this.topics.includes(topic.textContent.trim())));
    }
    renderQuestions(response) {
      const questionTemplate = this.querySelector("template[data-template-question]"), answerTemplate = this.querySelector("template[data-template-answer]"), container = this.querySelector("[data-questions]");
      this.currentQuestionPage = response.page, 1 == this.currentQuestionPage && (container.innerHTML = ""), 
      response.questions.forEach((review => {
        const questionClone = questionTemplate.content.cloneNode(!0);
        questionClone.querySelector("[data-content]").innerHTML = review.content, questionClone.querySelector("[data-asker]").innerHTML = review.asker.display_name, 
        review.sorted_public_answers.length && review.sorted_public_answers.forEach((answer => {
          const answerClone = answerTemplate.content.cloneNode(!0);
          answerClone.querySelector("[data-content]").innerHTML = answer.content, answerClone.querySelector("[data-answerer]").innerHTML = answer.answerer.display_name, 
          answer.store_owner_comment || answerClone.querySelector("[data-store-owner]").classList.remove("hidden"), 
          questionClone.appendChild(answerClone);
        })), container.appendChild(questionClone);
      })), response.questions.length >= this.perPage ? this.querySelector("[data-questions-loader]").classList.remove("hidden") : this.querySelector("[data-questions-loader]").classList.add("hidden");
    }
    async getFilteredReviews() {
      let page = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, url = new URL(`https://api-cdn.yotpo.com/v1/reviews/${this.appkey}/filter.json`);
      url.searchParams.set("per_page", this.perPage), url.searchParams.set("page", page);
      let body = {
        domain_key: parseInt(this.product.id),
        topic_names: this.topics
      };
      fetch(url, {
        ...this.options,
        method: "POST",
        body: JSON.stringify(body)
      }).then((res => res.json())).then((json => this.renderReviews(json.response))).catch((err => console.error("error:" + err)));
    }
    async getReviews() {
      let page = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, url = new URL(`https://api-cdn.yotpo.com/v1/widget/${this.appkey}/products/${this.product.id}/reviews.json`);
      url.searchParams.set("per_page", this.perPage), url.searchParams.set("page", page), 
      fetch(url, this.options).then((res => res.json())).then((json => this.renderReviews(json.response))).catch((err => console.error("error:" + err)));
    }
    async getQuestions() {
      let page = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, url = new URL(`https://api.yotpo.com/products/${this.appkey}/${this.product.id}/questions.json`);
      url.searchParams.set("per_page", this.perPage), url.searchParams.set("page", page), 
      fetch(url, this.options).then((res => res.json())).then((json => this.renderQuestions(json.response))).catch((err => console.error("error:" + err)));
    }
    async getTopics() {
      let url = new URL(`https://api-cdn.yotpo.com/v1/topic/${this.appkey}/topics.json`), body = {
        domain_key: parseInt(this.product.id)
      };
      fetch(url, {
        ...this.options,
        method: "POST",
        body: JSON.stringify(body)
      }).then((res => res.json())).then((json => this.renderTopics(json))).catch((err => console.error("error:" + err)));
    }
    init() {
      this.product = JSON.parse(this.querySelector('[type="application/json"]').textContent), 
      this.getTopics(), this.getReviews(), this.getQuestions();
    }
  });
}();